export const searchByKeywords = (items, query, keys) => {
	if (!query || !query.trim()) return items;

	const keywords = query.toLowerCase().split(" ").filter(Boolean);

	return items.filter((item) =>
		keywords.every((keyword) =>
			keys.some((key) => {
				const value = item[key];
				return value && value.toString().toLowerCase().includes(keyword);
			})
		)
	);
};
